import { Link } from "office-ui-fabric-react"

const AzureADSyncSettingsTooltip = () => {
    return <div>
        Configure fields mapping between Azure Active Directory and PPM Express Resources.
        <br />
        Please refer to the <Link href="https://help.ppm.express/111183-resource-management/1391517" target="_blank">article</Link> for more details.
    </div>
}

export default AzureADSyncSettingsTooltip;